import { gql, type OperationVariables } from '@apollo/client';
import { cloneDeep } from '@apollo/client/utilities';
import { setCompanyAllRoles } from '@store/reducer/companyReducer';
import { setEmployeeRoles } from '@store/reducer/employeeReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

const query = gql`
mutation createAndMapRole($title: String!) {
    createAndMapRole(title: $title) 
},
`;

/**
 * Creates and maps a role.
 *
 * @param {string} title - The title of the role.
 * @returns {Promise<number>} - A promise that resolves with the created role's ID.
 */
export default async function createAndMapRole(title: string) {
    const variables: OperationVariables = {
        title,
    };
    return GraphQL.mutate<number>(query, variables).then((result) => {
        const state = store.getState();
        const newRoles = cloneDeep(state.employee.roles);
        newRoles.push({ id: result, title: title });
        store.dispatch(setEmployeeRoles(newRoles));
        const newAllRoles = [...state.company.allRoles];
        newAllRoles.push({ title: title, id: result, otherNames: [], version: 0 });
        store.dispatch(setCompanyAllRoles(newAllRoles));
        return result;
    });
}
